import { css } from "styled-components";
export var pageMaxWidthCss = css(["max-width:1600px;margin:0 auto;width:100%;"]);
export var loadingStateCss = css(["", ""], function (_ref) {
  var $isLoading = _ref.$isLoading;
  return $isLoading ? css(["*{color:transparent !important;text-shadow:0 0 10px rgba(0,0,0,0.5) !important;}a:after,div:after,svg{opacity:0.2;}"]) : "";
});